import { render } from "./ReceiptTemplate.vue?vue&type=template&id=c0816a9a"
import script from "./ReceiptTemplate.vue?vue&type=script&lang=js"
export * from "./ReceiptTemplate.vue?vue&type=script&lang=js"

import "./ReceiptTemplate.vue?vue&type=style&index=0&id=c0816a9a&slot-scope=true&lang=css"
import "./ReceiptTemplate.vue?vue&type=style&index=1&id=c0816a9a&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Student_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__